module.exports = __webpack_public_path__ + "img/austria-other-heart-diseases-male.4245ecc6.png";